export default [
  {
    check: true,
    title: "공통사항",
    list: [
      {
        tableHeaderTitle: "작업전 안전조치 및 확인 점검 사항(이행여부 = V, 해당사항없음 = N/A)",
        list: [
          {
            content: "(현장) 작업 전 안전보건교육은 실시하였는가?(신규, 특별교육/TBM 활동 등)",
            isChecked: "",
          },
          {
            content: "(현장) 작업자에게 작업방법, 순서 등이 전달되었는가?",
            isChecked: "",
          },
          {
            content: "(현장) 작업자는 개인보호구를 착용하고 있는가?(필수: 안전모, 안전화 ,안전그네 등)",
            isChecked: "",
          },
          {
            content: "(현장)유해 ·위험기계기구는 반입 전 안전점검을 받았는가? (점검필증 확인)",
            isChecked: "",
          },
          {
            content: "(현장)작업장통로/계단 등 안전조치는 충분히 확보되어 있는가?",
            isChecked: "",
          },
          {
            content: "(현장)작업장소의 조도는 충분하게 확보되어 있는가?",
            isChecked: "",
          },
          {
            content: "(현장)해당작업에 대한 위험표지 및 안내간판 등은 설치되어 있는가?",
            isChecked: "",
          },
          {
            content: "(현장)화학물질에 대한 물질안전보건자료 (MSDS)가 비치. 게시되어 있는가?",
            isChecked: "",
          },
          {
            content: "(현장)작업자의 건강상태 이상유무 (고혈압, 고지혈증, 기타 질환)를 확인하였는가?",
            isChecked: "",
          },
          {
            content: "(현장)블랙박스가 비치 되어있고 작동여부를 확인하였는가?",
            isChecked: "",
          },
        ],
      },
    ],
  },
  {
    check: false,
    title: "외부 로프 작업",
    list: [
      {
        tableHeaderTitle: "작업전 안전조치 및 확인 점검 사항(이행여부 = V, 해당사항없음 = N/A)",
        list: [
          {
            content: "(서류) 작업 전 로프, 달비계, 장비 등 반입기준을 수립하였는가?",
            isChecked: "",
          },
          {
            content: "(현장) 작업책임자/상부 감시원는 배치되었는가?",
            isChecked: "",
            sign: [
              { name: "책임자", value: "" },
              { name: "감시원", value: "" },
            ],
          },
          {
            content: "(현장) 작업 구간에 동시작업 및 간섭사항을 확인하고 작업구간을 통제하였는가?",
            isChecked: "",
          },
          {
            content: "(현장) 인양도구 점검, 모서리 로프 보양 및 로프(8자/2중 매듭/시건 관리) 확인하였는가?",
            isChecked: "",
          },
          {
            content: "(현장) 작업자가 항시 추락 방지대를 올바르게 사용하고 있는가?",
            isChecked: "",
          },
        ],
      },
    ],
  },
  {
    check: false,
    title: "지하층 용접 및 융단 작업",
    list: [
      {
        tableHeaderTitle: "작업전 안전조치 및 확인 점검 사항(이행여부 = V, 해당사항없음 = N/A)",
        list: [
          {
            content: "(현장) 작업책임자/화재감시자는 배치되었는가?",
            isChecked: "",
            sign: [
              { name: "책임자", value: "" },
              { name: "감시원", value: "" },
            ],
          },
          {
            content: "(현장) 소화기 및 방화수 등 간이 소화장치는 비치하였는가?",
            isChecked: "",
          },
          {
            content: "(현장) 작업구간에 인화성물질 등 화재 발생 요인은 없는가?",
            isChecked: "",
          },
          {
            content: "(현장) 불티비산방지시설 및 비상통로 유도등은 설치하였는가?",
            isChecked: "",
          },
          {
            content: "(현장) 비상 경보장치는 작동되고 있는가?",
            isChecked: "",
          },
          {
            content: "(현장) 화재감시인에 확성기, 방염 마스크, 휴대용 손전등은 착용하고 있는가?",
            isChecked: "",
          },
        ],
      },
    ],
  },
  {
    title: "천정 상부(내부) 작업",
    list: [
      {
        tableHeaderTitle: "작업전 안전조치 및 확인 점검 사항(이행여부 = V, 해당사항없음 = N/A)",
        list: [
          {
            content: '(서류) 해당 작업에 대한 "안전작업계획서"는 작성되었는가? (계획서 및 도면 등)',
            isChecked: "",
          },
          {
            content: "(현장) 천정 상부 진입 통로 및 조명은 확보하였는가?",
            isChecked: "",
          },
          {
            content: "(현장) 근로자 출입 Log sheet 는 비치되었는가?",
            isChecked: "",
          },
          {
            content: "(현장) Blind Panel Opening 구간 확인 및 안전시설은 설치하였는가?",
            isChecked: "",
          },
          {
            content: "(서류) 작업책임자 배치 계획 수립 여부?",
            isChecked: "",
            sign: [{ name: "책임자", value: "" }],
          },
          {
            content: "(현장) 작업 구간 하부 출입금지 조치는 하였는가?",
            isChecked: "",
          },
        ],
      },
    ],
  },
  {
    check: false,
    title: "화기작업",
    list: [
      {
        tableHeaderTitle: "전기용접기 작업",
        list: [
          {
            content: "보안면 등 보호구 착용 여부",
            isChecked: "",
          },
          {
            content: "접지 홀더 및 충전부 절연상태",
            isChecked: "",
          },
          {
            content: "전격방지기 설치 작동 여부",
            isChecked: "",
          },
          {
            content: "소화기 배치 여부",
            isChecked: "",
          },
          {
            content: "불티비산방지포 설치 여부",
            isChecked: "",
          },
          {
            content: "접지 및 ELB설치 여부",
            isChecked: "",
          },
        ],
      },
      {
        tableHeaderTitle: "산소절단 작업",
        tableHeaderCheck: [{ text: "적정" }, { text: "미흡" }, { text: "해당없음" }],
        list: [
          {
            content: "보안면 등 보호구 착용 여부",
            isChecked: "",
          },
          {
            content: "산소,LPG 게이지 상태",
            isChecked: "",
          },
          {
            content: "전용대차 사용 여부(가스용기 고정 상태 여부)",
            isChecked: "",
          },
          {
            content: "소화기 배치 여부",
            isChecked: "",
          },
          {
            content: "불티비산방지포 설치 여부",
            isChecked: "",
          },
          {
            content: "리드선 손상여부 및 결속상태",
            isChecked: "",
          },
          {
            content: "역화 방지기 설치 상태",
            isChecked: "",
          },
        ],
      },
      {
        tableHeaderTitle: "그 외 불티비산작업",
        tableHeaderCheck: [{ text: "적정" }, { text: "미흡" }, { text: "해당없음" }],
        list: [
          {
            content: "해당작업유형에 맞게 점검",
            isChecked: "",
            sign: [{ name: "", value: "", valueWidth: "100%" }],
          },
        ],
      },
      {
        tableHeaderTitle: "안전작업 수칙(공통사항)",
        tableHeaderCheck: [{ text: "적정" }, { text: "미흡" }, { text: "해당없음" }],
        list: [
          {
            content: "화재감시자 배치 및 화재감시자용 장비 지급 여부",
            isChecked: "",
          },
          {
            content: "방연마스크 지급 여부",
            isChecked: "",
          },
          {
            content: "특별교육 이행 여부",
            isChecked: "",
          },
          {
            content: "주변에 가연성 물질이 없는가?",
            isChecked: "",
          },
          {
            content: "불티비산방지포 설치 여부",
            isChecked: "",
          },
          {
            content: "배치전 건강검진 실시(용접 흄 발생시의 경우)",
            isChecked: "",
          },
          {
            content: "허가받은 작업자는 작업이 끝난 후 최소 30분동안 그 작업에 대기하며 관찰한 후 작업완료 보고를 하였는가?",
            isChecked: "",
          },
          {
            rowType: "textarea",
            content: "조치사항",
          },
        ],
      },
    ],
  },
  {
    check: false,
    title: "고소작업",
    list: [
      {
        tableHeaderTitle: "작업 전 점검사항",
        list: [
          {
            content: "작업에 적합한 작업발판(비계, 사다리 등) 사용 하였는가?",
            isChecked: "",
          },
          {
            content: "안전모, 안전대 등 개인보호구 지급 및 착용 하였는가?",
            isChecked: "",
          },
          {
            content: "고소작업 구간 상·하 동시작업을 금지하고 있는가?",
            isChecked: "",
          },
          {
            content: "안전난간, 추락방지망 설치 등 추락 방지 조치를 하였는가?",
            isChecked: "",
          },
          {
            rowType: "textarea",
            content: "작업 전 조치사항",
          },
        ],
      },
      {
        tableHeaderTitle: "작업 후 점검사항",
        list: [
          {
            content: "근로자는 작업완료를 작업책임자(또는 업무담당자)에게 알렸는가?",
            isChecked: "",
          },
          {
            content: "작업책임자(또는 업무담당자)는 작업한 장소를 직접 확인했는가?",
            isChecked: "",
          },
          {
            content: "작업 종료 후 상부 작업 장소 자재 등 낙하 위험이 없는가?",
            isChecked: "",
          },
          {
            content: "작업 후 작업장소에 별다른 이상없이 안전한가?",
            isChecked: "",
          },
          {
            rowType: "textarea",
            content: "작업 전 조치사항",
          },
        ],
      },
    ],
  },
  {
    check: false,
    title: "외벽청소(리프트, 달비계)",
    list: [
      {
        title: "리프트",
        tableHeaderTitle: "작업 전 점검사항",
        list: [
          {
            content: "리프트에 작업자가 보기 쉬운 곳에 정격하중, 운전속도, 경고표시 등을 표시하였는가?",
            isChecked: "",
          },
          {
            content: "과부하방지장치, 권과방지장치의 기능이 정상적으로 작동되는가?",
            isChecked: "",
          },
          {
            content: "비상정지 스위치는 돌출형(적색) 구조로 적합한 위치에 설치, 정상적 으로 작동되는가?",
            isChecked: "",
          },
          {
            content: "조작스위치는 외부의 안전한 위치에 설치되어 있는가?",
            isChecked: "",
          },
          {
            content: "운반구 외부에 부착된 리미트 스위치는 변형, 훼손 없이 견고하게 설치되어 있는가?",
            isChecked: "",
          },
          {
            content: "고정볼트 등이 확실히 고정되고 풀림, 변형이 없는가?",
            isChecked: "",
          },
          {
            content: "와이어로프에 소선 끊어짐이 없으며, 심하게 변형되거나 부식된 경우, 즉시 교체 가능한가?",
            isChecked: "",
          },
          {
            content: "체인에 심한 균열 또는 변형이 없고, 훼손된 체인은   즉시 교체 가능 한가?",
            isChecked: "",
          },
          {
            content: "바닥에 걸려 넘어질 자재, 공구 등을 방치를 하고 있는가?",
            isChecked: "",
          },
          {
            content: "작업근로자가 작업특성에 적합한 개인보호구를 착용하도록 관리 하는가?",
            isChecked: "",
          },
          {
            content: "고장, 수리, 점검 작업 시 주 전원을 차단하고 잠금장치 및 표지판을 부착하고 작업하고 있는가?",
            isChecked: "",
          },
        ],
      },
      {
        title: "달비계",
        tableHeaderTitle: "작업 전 점검사항",
        tableHeaderCheck: [{ text: "적정" }, { text: "미흡" }, { text: "해당없음" }],
        list: [
          {
            content: "수직구명줄 설치 및 안전대 착용를 하였는가?",
            isChecked: "",
          },
          {
            content: "수직구명줄 등 안전대 부착설비를 고정하기 위한 적절한 연결부재를 사용하였는가?",
            isChecked: "",
          },
          {
            content: "로프가 노후 되지 않았는지 점검 하였는가?(변형,부식,손상된로프)",
            isChecked: "",
          },
          {
            content: "달비계 로프결박 요령을 숙지하고 2개이상 지지점에 견고하게 고정하였는가?",
            isChecked: "",
          },
          {
            content: "충분한 길이의 로프를 사용 하고 있는가?",
            isChecked: "",
          },
          {
            content: "날카로운 모서리 부분 로프 보호덮개를 설치 하였는가?",
            isChecked: "",
          },
          {
            content: "낙하물 방지를 위한 작업 장소 하부 출입금지를 하였는가?",
            isChecked: "",
          },
          {
            content: "바람, 비 등 기상상태는 적정한가?",
            isChecked: "",
          },
        ],
      },
    ],
  },
];
